<template>
	<div :class="$style.root">
		<iframe
			:class="$style.preview"
			:srcdoc="html"
			allow="fullscreen"
			height="100%"
			sandbox="allow-scripts allow-popups allow-same-origin"
			title="Email preview"
			width="100%"
		/>
	</div>
</template>

<script>
import editorState from '@/store/editorState'
import { computed } from '@vue/composition-api'

export default {
	name: 'Content',
	setup() {
		const { getHtml } = editorState

		return {
			html: computed(() => getHtml.value).value,
		}
	},
}
</script>

<style lang="less" module>
.root {
	contain: content;
}

.preview {
	border: 0 none;
	object-fit: contain;
	object-position: top left;
}
</style>
